module.exports = __webpack_public_path__ + "img/quicktips36.5c394139.svg";